module.exports = __webpack_public_path__ + "static/img/banner.0dfd05f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/设备及原料/生命科学研究设备及原料/banner.png
// module id = lGzI
// module chunks = 16